import { useEffect, useState } from 'react'
import useLazyQueryApi from '../../../../../hooks/useLazyQuery'
import {
  ADD_NEW_TEST_GROUP,
  GET_REMAINING_TEST_GROUPS_OFFERED,
  GET_SELECTED_PRODUCTS,
} from '../../GraphQLQueries/ProductOffering'
import useApi from '../../../../../hooks/useQuery'
import clsx from 'clsx'
import { ProductsModel } from './modals/productsModel'
import useMutationApi from '../../../../../hooks/useMutation'
import { LoadingSpinner } from '../../../../../_ePulse/layout/components/LoadingSpinner'
import { ToastMessageContainer } from '../../../../../_ePulse/layout/components/ToastMessageContainer'
import { toast } from 'react-toastify'

const ProductOfferings = () => {
  const [modalShow, setModalShow] = useState(0)
  const [field, setfield] = useState('')
  const [productList, setProductList] = useState<any[]>([])
  const [specificProductList, setSpecificProductList] = useState<any[]>([])
  
  // Track if the user has modified the checkboxes
  const [isDirty, setIsDirty] = useState(false)

  const {
    loading: loadingData,
    data: productData,
    refetch: refetchList,
  } = useApi('', GET_SELECTED_PRODUCTS, {})

  const {
    loading: loadingProducts,
    data: products,
    fetchData: refetchData,
  } = useLazyQueryApi('', GET_REMAINING_TEST_GROUPS_OFFERED)

  const { createData, loading } = useMutationApi(ADD_NEW_TEST_GROUP)

  const [isTabMenu, setIsTabMenu] = useState(true)

  useEffect(() => {
    if (productData?.getBusinessProductOffering?.length > 0) {
      const firstProduct = productData.getBusinessProductOffering[0]
      setProductList(productData.getBusinessProductOffering)
      setfield(firstProduct.productValue)
      refetchData({ productValue: firstProduct.productValue })
    }
  }, [productData])

 
  useEffect(() => {
    if (products?.getInActiveBusinessProductGroup) {
      setSpecificProductList(products.getInActiveBusinessProductGroup)
      setIsDirty(false) // Reset interaction state for the new product view
    }
  }, [products])

  const handleCheckboxChange = (id: string) => {
    setIsDirty(true) 
    setSpecificProductList((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, isActive: !item.isActive } : item
      )
    )
  }

  const AddProductApiCall = async () => {
    const filtered = specificProductList.filter((data: any) => data?.isActive === true)

    // if (filtered.length === 0) {
    //   toast.error('Please select at least one Test Group.')
    //   return
    // }

    const newTestGroupInput = filtered.map((data: any) => ({
      testGroupLabel: data?.testGroupLabel,
      testGroupValue: data?.testGroupValue,
      groupId: data?.id,
      productGroup: data?.productGroup,
      isActive: data?.isActive,
    }))

    try {
      await createData({
        testGroupInput: newTestGroupInput,
      })
      toast.success('Test Groups added successfully!')
      setIsDirty(false) 
    } catch (error) {
      toast.error('Error in adding test groups!')
      console.error('Error creating test groups:', error)
    }
  }

  return (
    <div className='d-flex flex-column form-wrapper'>
      <LoadingSpinner isLoading={loading || loadingData || loadingProducts} />
      <ToastMessageContainer />

      {modalShow === 1 && (
        <ProductsModel
          onClose={() => setModalShow(0)}
          refetch={refetchList}
        />
      )}

      <div className='d-flex justify-content-between align-items-center'>
        <h2 className='page-title'>Product Offering</h2>
        <button
          className='ePulse-button'
          onClick={() => setModalShow(1)}
        >
          Select Product
        </button>
      </div>

      <hr />

      <div className='vertical-tabs'>
        {/* Left Sidebar: Product List */}
        <div className={clsx(isTabMenu ? 'tab-list-container col-2' : 'tab-list-container col-2 menuOpen')}>
          <div className='tab-list' style={{ height: '400px', overflow: 'hidden auto' }}>
            {productList.length > 0 ? (
              productList.map((tab: any) => (
                <button
                  key={tab.id}
                  className={`tab ${field === tab.productValue ? 'active' : ''}`}
                  onClick={() => {
                    setfield(tab.productValue)
                    refetchData({ productValue: tab.productValue })
                  }}
                >
                  {tab.productName}
                </button>
              ))
            ) : (
              <div className='p-3 text-muted'>No Products Found</div>
            )}
          </div>
        </div>

        {/* Right Content: Test Groups Checkboxes */}
        <div className='tab-content'>
          {specificProductList.length > 0 ? (
            <>
              <div className='checkbox-list'>
                {specificProductList.map((product: any) => (
                  <div
                    className='d-flex justify-content-between align-items-center border p-3 mb-2 bg-white rounded'
                    key={product.id}
                  >
                    <span className='h5 mb-0'>{product.testGroupLabel}</span>
                    <input
                      type='checkbox'
                      style={{ cursor: 'pointer' }}
                      id={product.id}
                      checked={product.isActive || false}
                      onChange={() => handleCheckboxChange(product.id)}
                    />
                  </div>
                ))}
              </div>

              {/* Only visible when a change is made */}
              {isDirty && (
                <div className='btn-row mt-4 d-flex justify-content-end'>
                  <button
                    className='ePulse-btn-primary'
                    type='button'
                    onClick={AddProductApiCall}
                  >
                    Continue
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className='text-center p-5 border dashed'>
              {loadingProducts ? 'Loading Test Groups...' : 'No available test groups for this product.'}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProductOfferings